import styled from 'styled-components';

import ContractDetails from '../../../../components/ContractDetails';
import CopyField from '../../../../components/CopyField';
import colors from '../../../../styles/colors';

const DetailsPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCopyField = styled(CopyField)`
  width: 100%;
`;

const StyledContractDetails = styled(ContractDetails)`
  padding: 0;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

const InfoBox = styled.div`
  background: ${colors.shades.secondary10};
  border: 1px solid ${colors.shades.secondary4};
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
  color: ${colors.shades.secondary8};
  font-size: 14px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export {
  DetailsPanel,
  StyledCopyField,
  StyledContractDetails,
  Title,
  InfoBox,
};
